import { SET_CARD_STATE } from './actions';

const INITIAL_STATE = {
  stateMap: {},
};

export const getInitialState = () => ({
  ...INITIAL_STATE,
});

const cardReducer = (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case SET_CARD_STATE: {
      const { cardKey, cardState } = payload;
      return {
        ...state,
        stateMap: {
          ...state.stateMap,
          [cardKey]: cardState,
        },
      };
    }
    default:
      return state;
  }
};

export default cardReducer;
